// E-Ticaret Site Yönetimi sayfası kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'ecommerce.page';

export const ecommercePageGuide = (t: TFunction): GuideContent => ({
  layout: 'tabbed',
  title: t(`${G}.title`, 'E-Ticaret Site Yönetimi nasıl kullanılır?'),
  intro: t(`${G}.intro`, 'Web sitenizin siparişlerini, ürün ve kategori görünümünü, kampanyalarını, sayfa tasarımını ve içeriklerini tek sayfadan yönetirsiniz. Üstteki bölümlerden birini, ardından alt sekmeyi seçin. Haritada bir bölgeye tıklayarak o adıma geçebilirsiniz.'),
  navItems: [
    t(`${G}.nav.operations`, 'Operasyon'),
    t(`${G}.nav.catalog`, 'Ürün'),
    t(`${G}.nav.marketing`, 'Pazarlama'),
    t(`${G}.nav.design`, 'Site'),
    t(`${G}.nav.content`, 'İçerik'),
    t(`${G}.nav.b2b`, 'B2B'),
  ],
  regionLabels: {
    header: t(`${G}.regions.header`, 'Başlık ve görünüm anahtarları'),
    tabs: t(`${G}.regions.tabs`, 'Bölümler ve alt sekmeler'),
    body: t(`${G}.regions.body`, 'Seçili sekmenin ayarları'),
  },
  steps: [
    {
      region: 'tabs',
      title: t(`${G}.s1.title`, '1. Bölümü ve sekmeyi seçin'),
      text: t(`${G}.s1.text`, 'Üstteki bölüm düğmeleri ayarları gruplara ayırır; bir bölüme tıklayınca altında o bölümün sekmeleri çıkar. Sayfa Siparişler sekmesiyle açılır.'),
      tips: [
        t(`${G}.s1.tip1`, 'Operasyon: Siparişler, Üyeler, İadeler, Misafir Alışveriş.'),
        t(`${G}.s1.tip2`, 'Ürün: Liste, Kategoriler, Markalar. Pazarlama: Kampanyalar, Vitrin Alanları, Promosyon Kartları. Müşteri: Ürün Soruları, Yorumlar, Destek.'),
        t(`${G}.s1.tip3`, 'Site: Ana Sayfa, Slider, Sepet (Sayfa Düzeni) ile Genel, Üst Alan, Menü, Alt Alan, Giriş Sayfası (Site Çerçevesi).'),
        t(`${G}.s1.tip4`, 'İçerik: İletişim, Şubeler, Hakkımızda, Hizmetler, Ürün & Çözümler, Referanslar, Blog. Dinamik: Sayfalar, Formlar, S.S.S, Kartlar & Etiketler, Yasal Sözleşmeler. B2B: B2B Ayarları, Ödeme (Moka) Ayarları.'),
      ],
    },
    {
      region: 'header',
      title: t(`${G}.s2.title`, '2. Kurulum sihirbazını ve görünümü açın / kapatın'),
      text: t(`${G}.s2.text`, '"Kurulum sihirbazı" anahtarı açıkken bölümlerin başına "Kurulum Sihirbazı" eklenir; siteyi adım adım kurmanıza yardım eder. Kapatınca gizlenir. Bu tercih bu tarayıcıda hatırlanır.'),
      tips: [
        t(`${G}.s2.tip1`, '"Normal görünüm" anahtarı görünüyorsa: açıkken tüm bölümler üstte durur, kapatınca sade menüye geçilir ve az kullanılan sekmeler "Daha fazla" altında toplanır.'),
      ],
    },
    {
      region: 'body',
      title: t(`${G}.s3.title`, '3. Ürün listesini düzenleyin'),
      text: t(`${G}.s3.text`, 'Ürün › Liste sekmesindeki ürünler stoktan gelir: sitede yalnız e-ticarete açık stok kartları görünür. Yeni ürünü burada değil, stok kartında açarsınız. Bu listede satırdaki "Açıklamayı düzenle" simgesiyle ürünün sitede görünen açıklamasını düzenleyebilirsiniz; kaydedilen açıklama vitrindeki ürün detay sayfasında görünür.'),
    },
    {
      region: 'body',
      title: t(`${G}.s4.title`, '4. "Tüm Kategoriler" açılır panelini ayarlayın'),
      text: t(`${G}.s4.text`, 'Vitrinin üst menüsündeki "Tüm Kategoriler" açılır panelinin görünümü Ürün › Kategoriler sekmesinden seçilir; Üst Alan veya Menü sekmesinde aramayın. Üç şablondan birine tıklayın: Liste (yalnız metin), Minimal (resimli küçük kutular) veya Klasik (resimli klasik ızgara).'),
      tips: [
        t(`${G}.s4.tip1`, '"Tüm Kategoriler dropdown\'unu göster" kapalıysa bu panel vitrinde gizlenir.'),
        t(`${G}.s4.tip2`, 'Kategori görselleri Menü sekmesinden yüklenir; Minimal ve Klasik şablonlar bu görselleri kullanır.'),
      ],
    },
    {
      region: 'body',
      title: t(`${G}.s5.title`, '5. Değişiklikleri kaydedin'),
      text: t(`${G}.s5.text`, 'Birçok sekmede değişiklik yaptığınız anda otomatik kaydedilir ve kısa bir "kaydedildi" bildirimi çıkar. Kaydet düğmesi olan sekmelerde düğmeye basmayı unutmayın.'),
    },
    {
      region: 'header',
      title: t(`${G}.s6.title`, '6. Sekmelerin kendi rehberleri'),
      text: t(`${G}.s6.text`, 'Ana Sayfa, Kampanyalar, İadeler, B2B Ayarları gibi sekmelerin kendi (i) rehberi vardır; ayrıntılar orada anlatılır. Başlıktaki (i) bu genel rehberi yeniden açar.'),
    },
  ],
});
